export const normalizeLabelRotation = (angle: number): number => {
  if (!Number.isFinite(angle)) return 0;

  let normalized = ((angle + 180) % 360 + 360) % 360 - 180;
  if (normalized > 90) normalized -= 180;
  if (normalized < -90) normalized += 180;

  return normalized;
};